"use client";

import {
	QueryClient,
	QueryClientProvider as ReactQueryClientProvider,
} from "@tanstack/react-query";
import { useState } from "react";

const QueryClientProvider = ({ children }: React.PropsWithChildren) => {
	const [client] = useState(new QueryClient());

	return <ReactQueryClientProvider client={client}>{children}</ReactQueryClientProvider>;
};

export default QueryClientProvider;
